export const routes = {
  home: "/",
  profile: "/profile",
  login: "/login",
  register: "/register",

  userRPoint: "/user/r-point",
  userMep: "/user/mep",
  userVerify: "/user/verify",
  viewUser: "/user/user-detail/:id",
  viewCompany: "/company/:id",
  viewPortfolio: "/company/:companyId/portfolio/:id",
  addPortfolio: "/company/:companyId/portfolio/create",


  subscriptionPlans: "/subscriptions/plans",
  addSubscriptionPlan: "/subscriptions/plans/add",
  editSubscriptionPlan: "/subscriptions/plans/edit/:id",
  subscriptionFeatures: "/subscriptions/features",
  userSubscription: "/subscriptions",
  userSubscriptionDetails: "/subscriptions/:id",
  subscriptionPayments: "/subscriptions/payments",
  gisTrial: "/subscriptions/gis-trial",

  feedbackRpoint: "/feedback/rpoint",
  feedbackMep: "/feedback/mep",

  mapDynamic: "/map/:mapCode",
  mapGeoreference: "/maps/:mapCode/georeference/:fileId",
  mapGeoreferenceList: "/maps-georeference",
  mapGeoreferenceCreate: "/maps-georeference/create",
  mapGeoreferenceImport: "/maps-georeference/import",
  mapGeoreferenceImportDetail: "/maps-georeference/import/:importId",
  // dp:"/map/:mapCode",
  // village:"/map/:mapCode",
  // gdcr:"/map/:mapCode",

  jantriDynamic: "/jantri/:type",
  // nagarpalika:"/jantri/nagarpalika",
  // ruralagri:"/jantri/ruralagri",
  // ruralna:"/jantri/ruralna",

  banner: "/banner",
  addBanner: "/add-banner",
  editBanner: `/edit-banner/:id`,
  otpMessage: "/otpMessage",

  npaProperties: "/npa-properties",
  addNpaProperties: "/npa-properties/add",
  editNpaProperties: "/npa-properties/edit/:id",
  viewNpaProperties: "/npa-properties/property-details/:id",

  npaInquiries: "/npa-inquiries",

  bankUsers: "/all-users",


  banks: "/banks",
  viewBanksDetail: "/bank-details/:id",

  introductionScreens: "/introduction-screens",
  addIntroductionScreen: "/introduction-screens/add",
  editIntroductionScreen: "/introduction-screens/edit/:id",

  profileSuggestionCards: "/profile-suggestion-cards",

  marketPlace: "/market-place",
  viewMarketPlace: "/market-place/market-details/:id",
  editMarketPlace: "/market-place/edit/:id",
  bulkOffer: "/bulk-offer",

  setting: "/setting",

  marketplace: "/marketplace",
  marketplaceListings: "/marketplace/listings",
  marketplaceBulkOffers: "/marketplace/bulk-offers",
  createMarketplaceBulkOffer: "/marketplace/bulk-offers/create",
  editMarketplaceBulkOffer: "/marketplace/bulk-offers/edit/:id",
  viewMarketplaceBulkOffer: "/marketplace/bulk-offers/:id",
  marketplaceCategories: "/marketplace/categories",
  viewMarketplaceListing: "/marketplace/listings/:id",
  marketplaceBulkOfferRequests: "/marketplace/bulk-offer-requests",
  marketplaceBookings: "/marketplace/bookings",
  viewMarketplaceBooking: "/marketplace/bookings/:id",
  marketplaceRequirements: "/marketplace/requirements",
  test: "/test",

  company: "/company",
  allCompanies: "/company/all-companies",
  // viewAllCompany: "/company/all-companies/:id",
  verificationRequests: "/company/verification-requests",
  viewVerificationRequests: "/company/verification-requests/:id",

  adminManagement: "/admin-management",
  roles: "/admin-management/roles",
  adminUsers: "/admin-management/users",

  brokerCrm: "/broker-crm",
  brokerProperties: "/broker-crm/properties",
  addBrokerProperty: "/broker-crm/properties/add",
  editBrokerProperty: "/broker-crm/properties/edit/:id",
  viewBrokerProperty: "/broker-crm/properties/property-details/:id",
  brokerClients: "/broker-crm/clients",
  publicProperties: "/public-properties",
  publicLands: "/public-lands",
  addPublicProperty: "/public-properties/add",
  editPublicProperty: "/public-properties/edit/:id",
  viewPublicProperty: "/public-properties/:id",
  addPublicLand: "/public-lands/add",
  editPublicLand: "/public-lands/edit/:id",
  viewPublicLand: "/public-lands/:id",
};
